<template>
  <div class="relative locations-page">
    <div class="px30 pt30" v-if="!$getState('showGoogleMap') && !$getState('showAppFilters') && isLocations">
      <router-link :to="{
        path: '/dashboard'
      }" class="table">
        <Close icon="back" />
      </router-link>
    </div>
    <Post post-type="partner" :appTitle="appTitle"></Post>

  </div>
</template>

<script>
import Close from "../components/UI/Close";
import Post from "../components/Post/Post";

export default {
  name: "Locations",
  components: {
    Post,
    Close
  },
  data() {
    return {
      causeRedirectUrl: "",
      appTitle: ""
    };
  },
  computed: {
    isLocations() {
      return this.$route.path != '/locations'
    },
    corporationTitle: function () {
      const corpData = this.$getState("corporation");
      if (!!corpData.title && corpData.title.length) {
        return this.getLocalizationData(corpData.title);
      }
      return "Thrive";
    }
  },
  created() {
    this.$checkAvatar(this.$user("has_avatar"));
  },
  mounted() {
    this.$setState("showGoogleMap", false);
    this.$setState("showAppFilters", false);
    this.$setState("isNavigation", true);
    this.getUserNpos();
  },
  methods: {
    causeUrl: function (cause) {
      if (cause.length > 0) {
        this.causeRedirectUrl = `npos/${cause[0]["id"]}`;
      } else {
        this.causeRedirectUrl = "npos";
      }
    },
    getUserNpos: function () {
      this.$http.post("user/listnpo").then(res => {
        if (res && res.status !== undefined && res.status) {
          if (res.data.npo !== undefined) {
            this.causes = res.data.npo;
            this.causeUrl(this.causes);
            if (this.causes && this.causes.length > 0) {
              this.hasCauses = true;
            }
          }
        }
      });
    }
  }
};
</script>
<style>
</style>
